import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <footer className="Footer">
      <div className="footerContainer">
        <div className="footerLinks">
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <NavLink to="/privacy">Privacy Policy</NavLink>
          <NavLink to="/terms">Terms of Service</NavLink>
        </div>
        <p className="footerCopyright">
          &copy; {new Date().getFullYear()} Drafter. All rights reserved. Not
          affiliated with Riot Games.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
